// 1. React and fabric. 
import * as React from 'react';
// 2. Store and Types. 
import { IEditComponentProps, EditComponent } from '../types/EditComponent';
// 3. Scripts. 
// 4. Components and Views. 

export default class Blank extends React.PureComponent<IEditComponentProps>
{
	public get data(): any
	{
		return null;
	}

	public validate(): boolean
	{
		return true;
	}

	public updateDependancy(PARENT_FIELD: string, DATA_VALUE: any, PROPERTY_NAME?: string, item?: any): void
	{
	}

	public clear(): void
	{
	}

	constructor(props: IEditComponentProps)
	{
		super(props);
	}

	public render()
	{
		return (<span>&nbsp;</span>);
	}
}

